<template>
  <f7-popup :id="nameId" :opened="popupOpened"
    @popup:opened="popupOpened = true"
    @popup:closed="popupOpened = false"
    class="switchProfilePopup">
    <div class="switchProfileBack">
      <div class="switchProfileContent">
        <div class="switchProfileTitleBox">
          <a class="switchProfileTitle">{{ $t('leftPanelTitle.swtch_prfl') }}</a>
        </div>
        <f7-list media-list class="switchProfileList"> <!--  style="" -->
          <f7-list-item
            v-for="accountItem in accounts"
            :key="accountItem.id"
            class="boxRequest"
            :class="{'disabled' : false}"
            :media="'<div class=\'manualChip\'>'+accountItem.name[0].toUpperCase()+'</div>'"
            :title="accountItem.name"
            :subtitle="accountItem.identifier"
            :badge="selected(accountItem.id)"
            @click="switchAccount(accountItem.id)"
            text="">
          </f7-list-item>
        </f7-list>
        <f7-link class="cancelContainer">
          <div class="cancelBox">
            <f7-button class="confirmationButtonActivation close-popup">
              {{ $t('common.bck') }}  <f7-icon size="14px" f7="undo"></f7-icon>
            </f7-button>
          </div>
        </f7-link>
      </div>
    </div>
  </f7-popup>
</template>

<script>

import pageNavBar from '@/components/common/pageNavBar.vue'
// import {loadPage} from '@/helpers/routing'

export default {
  name: 'switch-profile',
  components: {
    'page-nav-bar': pageNavBar
  },
  props: {
    closeButton: Boolean
  },
  data: () => {
    return {
      accounts: [],
      popupOpened: false,
      nameId: ''
    }
  },
  created () {
    this.switchProfile_SwitchProfile = this.$i18n.t('leftPanelTitle.swtch_prfl')
    let that = this
    this.nameId = 'switch-profile-' + this.closeButton
    this.$bus.$on('refresh-cache-menu', (val) => {
      that.accounts = this.$engine.accounts.get()
    })
  },
  methods: {
    switchAccount (id) {
      this.$engine.accounts.switchToAccount(id)
      this.popupOpened = false
      this.$bus.emit('refresh-cache-menu')
      this.$bus.$emit('reload-app')
    },
    selected: function (accountId) {
      if (accountId === this.$engine.user.get().id) {
        return this.$i18n.t('common.slctd')
      }
    }
  }
}
</script>

<style scoped>
@media (max-width: 992px) {
  .switchProfileTitle {
    font-size: 2rem;
    font-weight: bolder;
    color: white;
  }
}
@media (min-width: 992px) {
  .switchProfileTitle {
    font-size: 3rem;
    font-weight: bolder;
    color: white;
  }
}
.switchProfileTitleBox {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 40%;
  text-align: center;
  vertical-align: middle;
}
.switchProfileBack {
  background: linear-gradient(to bottom, #000 20%, #FAFAFA 10%);
  display: flex;
  justify-content: center;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
.switchProfileContent {
  display: flex;
  justify-content: top;
  flex-direction: column;
  height: 100%;
  width: 80%;
}
.switchProfilePopup {
  border-radius: 1%;
  box-shadow: 5px 5px 5px black;
  overflow: hidden;
}
.list-block {
  height: auto;
  width: 100%;
}
.boxRequest {
  background-color: #FAFAFA;
  border-bottom: 1px solid black;
  cursor: pointer;
}
.boxRequest:hover {
  background-color: #a1cca8;
  border-bottom: 1px solid black;
  cursor: pointer;
}
.cancelContainer {
  display: flex;
  flex-direction: column-reverse;
  height: inherit;
}
.cancelBox {
  height: 15%
}
.confirmationButtonActivation {
  background-color: var(--actionButtonColor);
  border-color: var(--actionButtonColor);
  color: var(--actionTextColor) ;
}
.confirmationButtonActivation:hover {
  background-color: var(--actionButtonColorHover);
  color: var(--actionTextColorHover);
}
</style>



// WEBPACK FOOTER //
// switchProfile.vue?3dc2d724